module.exports = __webpack_public_path__ + "img/Bodice-Back-Jc-Kh-Lb.3724a8f3.png";